// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".otp[data-v-5ecb2990]{display:inline-block;width:43px;height:43px;margin:5px;text-align:center}.dropdown:hover .dropdown-menu[data-v-5ecb2990]{display:block}", ""]);
// Exports
module.exports = exports;
